import { encodedData } from '../../../../../lib/encrypt'

export const navigateWithoutRedirect = (key, value) => {
  if (window.history.replaceState) {
    const url = new URL(window.location.href)
    url.searchParams.set(key, encodedData(value))
    window.history.replaceState(null, '', url.toString())
  }
}
